import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f89de74e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%","display":"flex","flex-direction":"column"} }
const _hoisted_2 = { style: {"padding":"20px","flex-grow":"1","overflow":"auto"} }
const _hoisted_3 = { style: {"margin-top":"20px"} }
const _hoisted_4 = { style: {"margin-top":"20px"} }
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"20px 0"} }
const _hoisted_6 = { style: {"text-align":"center","font-size":"60px","background":"rgba(29, 165, 122, 0.25)","padding":"0 60px"} }
const _hoisted_7 = { class: "form-btn-group" }

import { inject, onMounted, onUnmounted, reactive } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import { request } from '@/util/request';
import { message } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BindCode',
  setup(__props) {

const data = reactive({
  loading: false,
  status: false,
  code: '',
  time: 0,
  end: 0,
});

onMounted(async () => {
  data.loading = true;
  const res = await request('/management/device/getCode');
  if (res) {
    if (res.code) {
      data.status = true;
      data.code = res.code;
      data.end = Date.now() + res.time;
      computeTime()
    }
  }
  data.loading = false;
});

function formatTime(ms: number) {
  const seconds = Math.floor(ms / 1000);
  const hours = Math.floor(seconds / 3600); // 获取小时
  const minutes = Math.floor((seconds % 3600) / 60); // 获取分钟
  const remainingSeconds = seconds % 60; // 获取剩余的秒数
  if (hours > 0) return `${hours}小时${minutes}分钟${remainingSeconds}秒`;
  if (minutes > 0) return `${minutes}分钟${remainingSeconds}秒`;
  if (remainingSeconds > 0) return `${remainingSeconds}秒`;
  return '0';
}

let countdown: number | undefined;

function computeTime() {
  data.time = data.end - Date.now();
  if (data.time <= 0) {
    data.status = false;
  }
}

onMounted(() => {
  countdown = setInterval(computeTime, 1000);
});
onUnmounted(() => {
  clearInterval(countdown);
});

async function onChange(value: boolean) {
  await toggleCode(value ? 'gen' : 'del');
}

async function renew() {
  const old = data.code;
  if ((await toggleCode('renew')) && data.code != old) {
    message.warn('原绑定已过期无法续期，已为您生成码');
  }
}

async function toggleCode(action: 'del' | 'gen' | 'renew') {
  data.loading = true;
  const res = await request('/management/device/toggleCode', {
    action,
  });
  data.loading = false;
  if (res) {
    if (res.code) {
      data.status = true;
      data.code = res.code;
      data.end = Date.now() + res.time;
      computeTime()
      return true;
    } else {
      data.status = false;
    }
  }
}

const windowTool = inject<WindowTool | false>(WindowTool, false);

function close() {
  if (windowTool) {
    windowTool.close(true);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_switch, {
        checked: data.status,
        onChange: onChange,
        loading: data.loading,
        "checked-children": "开启",
        "un-checked-children": "关闭"
      }, null, 8, ["checked", "loading"]),
      (data.status)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ScBtn, {
                text: "重新生成",
                style: {"margin-right":"12px"},
                handler: () => toggleCode('gen')
              }, null, 8, ["handler"]),
              _createVNode(ScBtn, {
                text: "重置有效期",
                handler: renew
              })
            ]),
            _createElementVNode("div", _hoisted_4, " 剩余时间：" + _toDisplayString(formatTime(data.time)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(data.code), 1)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(ScBtn, {
        handler: close,
        text: "关闭",
        type: "primary"
      })
    ])
  ]))
}
}

})